import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
declare var $: any;
import * as _ from 'lodash';
import { EcsService } from 'src/app/services/ecs.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidation } from 'src/app/helpers/customValidation';
@Component({
  selector: 'app-ecs',
  templateUrl: './ecs.component.html',
  styleUrls: ['./ecs.component.css']
})
export class EcsComponent implements OnInit {

  ecsForm: FormGroup;
  ecsList: any[];
  dateOfBMModel: any;
  ParticularId: any;
  addBtn = true;
  editEcsData: any = [];
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnclick: boolean;

  constructor(private EcsService: EcsService, private alert: AlertComponent, private activatedRoute: ActivatedRoute,
    private customValidations: CustomValidation,private router: Router) { }

  ngOnInit() {
    this.ecsForm = new FormGroup({
      nameofbank: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z.' ,-]*$"), this.customValidations.noWhitespaceValidator]),
      nameofbranch: new FormControl('', [Validators.pattern("^[a-zA-Z., '][a-zA-Z.,' ]*$")]),
      addressofbank: new FormControl('', []),
      typeofaccount: new FormControl('', [Validators.required, this.customValidations.noWhitespaceValidator]),
      bankaccountnumber: new FormControl('', [Validators.minLength(8), Validators.maxLength(20)]),
      ifsccode: new FormControl('', []),
      dateOfBM: new FormControl('', []),
      authorizedsign: new FormControl('', []),
      remarks: new FormControl('', [])
    })
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.ParticularId = params['particularId'];
        this.getEcsById(this.ParticularId);
      } else {
        this.addBtn = true;
      }
    })
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ecslist']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;

    }
    return null;
  }

  saveEcsData() {
    this.disabledOnclick = true;
    var object = {
      nameofbank: this.ecsForm.controls.nameofbank.value,
      nameofbranch: this.ecsForm.controls.nameofbranch.value,
      addressofbank: this.ecsForm.controls.addressofbank.value,
      typeofaccount: this.ecsForm.controls.typeofaccount.value,
      bankaccountnumber: this.ecsForm.controls.bankaccountnumber.value,
      ifsccode: this.ecsForm.controls.ifsccode.value,
      dateOfBM: this.setDate(this.ecsForm.controls.dateOfBM.value),
      authorizedsign: this.ecsForm.controls.authorizedsign.value,
      remarks: this.ecsForm.controls.remarks.value

    }

    this.EcsService.sampleEcsRecord(object).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'ecslist')
      } else {
        // this.alert.error(response.message);
      if(response.err_fields){
        for(let i=0; i<response.err_fields.length; i++){
          // if((response.err_fields[i] == "nameofbank") && (response.err_fields[i] == "typeofaccount" ) ){
          //   this.alert.error( 'Name of the bank and Type of Account fields are required or invalid.');
          // }
         
          if(response.err_fields[i] == "nameofbank"){
          this.alert.error( 'Name of the bank field are required or invalid.');
          }
          else if(response.err_fields[i] == "typeofaccount"){
            this.alert.error( 'Type of Account field are required or invalid.');
          }
          else if(response.err_fields[i] == "nameofbranch"){
            this.alert.error( 'Name of Branch field are required or invalid.');
          }
          else if(response.err_fields[i] == "bankaccountnumber"){
            this.alert.error( 'Bank Account Number field are required or invalid.');
          }

          else{
            this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          }
        };
      }
      else{
        this.alert.error(response.message);
      }
      }
    })
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getEcsById(particularId) {
    this.EcsService.getEcsDetail(particularId).subscribe(response => {

      this.editEcsData = response.data[0];
      this.ecsForm.controls.nameofbank.setValue(this.editEcsData.nameofbank);
      this.ecsForm.controls.nameofbranch.setValue(this.editEcsData.nameofbranch);
      this.ecsForm.controls.addressofbank.setValue(this.editEcsData.addressofbank);
      this.ecsForm.controls.typeofaccount.setValue(this.editEcsData.typeofaccount);
      this.ecsForm.controls.bankaccountnumber.setValue(this.editEcsData.bankaccountnumber);
      this.ecsForm.controls.ifsccode.setValue(this.editEcsData.ifsccode);
      this.ecsForm.controls.dateOfBM.setValue(this.editEcsData.dateOfBM);
      this.ecsForm.controls.authorizedsign.setValue(this.editEcsData.authorizedsign);
      this.ecsForm.controls.remarks.setValue(this.editEcsData.remarks);


      if (this.editEcsData.dateOfBM != null) {
        let dt = new Date(this.setFormatDate(this.editEcsData.dateOfBM));
        this.dateOfBMModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    })
  }


  updateBankAccountParticulars(_id) {
    this.disabledOnclick = true;
    var ecsObject = {
      nameofbank: this.ecsForm.controls.nameofbank.value,
      nameofbranch: this.ecsForm.controls.nameofbranch.value,
      addressofbank: this.ecsForm.controls.addressofbank.value,
      typeofaccount: this.ecsForm.controls.typeofaccount.value,
      bankaccountnumber: this.ecsForm.controls.bankaccountnumber.value,
      ifsccode: this.ecsForm.controls.ifsccode.value,
      dateOfBM: this.setDate(this.ecsForm.controls.dateOfBM.value),
      authorizedsign: this.ecsForm.controls.authorizedsign.value,
      remarks: this.ecsForm.controls.remarks.value,
    }

    var self = this;
    self.EcsService.updateEcsDetails(ecsObject, self.ParticularId).subscribe(response => {
      self.disabledOnclick = false;
      if (response.status == 0) {
        self.alert.successWithOk(response.message, 'ecslist')
      } else {
        // self.alert.error(response.message);
       
        // self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        // if(response.err_fields){
        //   self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        // }
        if(response.err_fields){
          for(let i=0; i<response.err_fields.length; i++){
            // if((response.err_fields[i] == "nameofbank") && (response.err_fields[i] == "typeofaccount" ) ){
            //   this.alert.error( 'Name of the bank and Type of Account fields are required or invalid.');
            // }
           
            if(response.err_fields[i] == "nameofbank"){
             self.alert.error( 'Name of the bank field are required or invalid.');
            }
            else if(response.err_fields[i] == "typeofaccount"){
               self.alert.error( 'Type of Account field are required or invalid.');
            }
            else if(response.err_fields[i] == "nameofbranch"){
               self.alert.error( 'Name of Branch field are required or invalid.');
            }
            else if(response.err_fields[i] == "bankaccountnumber"){
               self.alert.error( 'Bank Account Number field are required or invalid.');
            }
  
            else{
               self.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
            }
          };
        }
        else{
          self.alert.error(response.message);
        }
      }
    })
  }


  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  generateOutput() {
    var object = {
      id: this.ParticularId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.EcsService.generateEcsDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.ParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.ParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.EcsService.downloadEcsFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.EcsService.downloadEcsPdfFile(id, 'Single');
  }

}
